<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "Index",
  created() {
    //window.history.pushState(null, null, document.URL)
  },
}
</script>

<style scoped>

</style>